import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../actions/LoginActions";
import "../styles/HeaderComponent.css";

function HeaderComponent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">CDL Admin</Link>
      </div>
      <div className="nav-links">
        <Link to="/">Home</Link>
        {isLoggedIn && <Link to="/admin/create">Create News</Link>}
        {isLoggedIn ? (
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        ) : (
          <Link to="/login">Login</Link>
        )}
      </div>
    </header>
  );
}

export default HeaderComponent;
